import React, { useCallback, useEffect, useState } from 'react';
import { List, X, ArrowLeft } from '@phosphor-icons/react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { usePortfolio } from '../context/PortfolioContext';
export function CaseStudyHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const {
    viewPreference,
    openChatDrawer,
    previousPage,
    setPreviousPage,
    isChatDrawerOpen
  } = usePortfolio();
  // Throttle function
  const throttle = (func: Function, delay: number) => {
    let lastCall = 0;
    return function (...args: any[]) {
      const now = new Date().getTime();
      if (now - lastCall < delay) {
        return;
      }
      lastCall = now;
      return func(...args);
    };
  };
  const checkBackground = useCallback(throttle(() => {
    const scrolled = window.scrollY > 10;
    setHasScrolled(scrolled);
    setIsAtTop(!scrolled);
  }, 50), [hasScrolled]);
  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const homePath = viewPreference === 'ai' ? '/portfolio/ai' : '/portfolio/traditional';
    if (location.pathname === homePath) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      navigate(homePath);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      checkBackground();
    }, 100);
    window.addEventListener('scroll', checkBackground);
    return () => {
      window.removeEventListener('scroll', checkBackground);
    };
  }, [checkBackground]);
  useEffect(() => {
    setHasScrolled(false);
    setIsAtTop(true);
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const homePath = viewPreference === 'ai' ? '/portfolio/ai' : '/portfolio/traditional';
  const handleSectionClick = (sectionId: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === homePath) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      navigate(homePath);
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
    toggleMenu();
  };
  return <>
      {/* FIXED: Match Header.tsx positioning exactly - use right adjustment instead of width */}
      <header className="fixed top-0 left-0 z-[9999] p-6 flex justify-between items-start transition-all duration-300" style={{
      pointerEvents: 'none',
      right: isChatDrawerOpen ? '420px' : '0'
    }} data-id="element-83" data-mp="3qw8a952tzin8">
        {/* Logo */}
        <div className="relative flex items-center justify-center" style={{
        width: '36px',
        height: '36px',
        pointerEvents: 'auto'
      }} data-id="element-84" data-mp="urz2nl7u3pn9">
          {/* White background - consistent size across all screens */}
          <div className={`absolute bg-white rounded-md shadow-md left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-300 w-[54px] h-[54px]
              ${hasScrolled ? 'opacity-100' : 'opacity-0'}`} style={{
          zIndex: 1
        }} data-id="element-85" data-mp="14s9ep2i4ur0u"></div>

          <a href={homePath} className="logo-container relative flex items-center justify-center w-9 h-9 cursor-pointer" onClick={handleLogoClick} style={{
          zIndex: 10
        }} data-id="element-86" data-mp="1ngmtrxf9l98q">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/blacklogom.png" alt="Mateo Cohen Logo" className="h-[34px] w-auto object-contain transition-all duration-300" style={{
            zIndex: 10,
            pointerEvents: 'auto'
          }} data-id="element-87" data-mp="1wiw0sdbbqkhd" />
          </a>
        </div>

        {/* Menu button */}
        <div className="relative flex items-center justify-center" style={{
        width: '36px',
        height: '36px',
        pointerEvents: 'auto'
      }} data-id="element-88" data-mp="1slgmcgmhmdjo">
          {/* White background - consistent size across all screens */}
          <div className={`absolute bg-white rounded-md shadow-md left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-300 w-[54px] h-[54px]
              ${hasScrolled ? 'opacity-100' : 'opacity-0'}`} style={{
          zIndex: 1
        }} data-id="element-89" data-mp="1ets7w6ornczj"></div>

          <button onClick={toggleMenu} className="relative flex items-center justify-center w-9 h-9 cursor-pointer rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-4" aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} style={{
          zIndex: 10,
          pointerEvents: 'auto'
        }} data-id="element-90" data-mp="2l8b0ywwmiip8">
            <List className="w-8 h-8 text-black transition-colors duration-300" style={{
            zIndex: 10
          }} data-id="element-91" data-mp="31b1z2dcz63s" />
          </button>
        </div>
      </header>

      {isMenuOpen && <div className="fixed inset-0 bg-black bg-opacity-95 z-[10000] flex items-center justify-center transition-all duration-300" data-id="element-92" data-mp="gy6ghacdppr8">
          <button onClick={toggleMenu} className="absolute top-6 right-6 text-white focus:outline-none" aria-label="Close menu" data-id="element-93" data-mp="lw7x7omc1czj">
            <X className="w-8 h-8" data-id="element-94" data-mp="1efetm1wh4i5o" />
          </button>
          <nav className="text-center" data-id="element-95" data-mp="1oabztlg6qbi8">
            <ul className="space-y-8" data-id="element-96" data-mp="1o9arvpugu54q">
              <li data-id="element-97" data-mp="1o89dbbe8r0i9">
                <Link to={homePath} className="text-2xl sm:text-3xl text-white font-semibold tracking-normal hover:text-gray-400 transition-colors duration-300 font-switzer" onClick={toggleMenu} data-id="element-98" data-mp="1jbsgztww1fu3">
                  HOME
                </Link>
              </li>
              <li data-id="element-99" data-mp="15cja5kukny2s">
                <a href="#featured-work" className="text-2xl sm:text-3xl text-white font-semibold tracking-normal hover:text-gray-400 transition-colors duration-300 font-switzer" onClick={handleSectionClick('featured-work')} data-id="element-100" data-mp="15d2h66iop221">
                  FEATURED WORK
                </a>
              </li>
              <li data-id="element-101" data-mp="lo0imwm3g8kx">
                <a href="#projects" className="text-2xl sm:text-3xl text-white font-semibold tracking-normal hover:text-gray-400 transition-colors duration-300 font-switzer" onClick={handleSectionClick('projects')} data-id="element-102" data-mp="ln8uu7yqnf57">
                  CASE STUDIES
                </a>
              </li>
              <li data-id="element-103" data-mp="32aglele1lwbm">
                <a href="#about" className="text-2xl sm:text-3xl text-white font-semibold tracking-normal hover:text-gray-400 transition-colors duration-300 font-switzer" onClick={handleSectionClick('about')} data-id="element-104" data-mp="329x9pmezk461">
                  ABOUT ME
                </a>
              </li>
              <li data-id="element-105" data-mp="2eijl9rjygsqc">
                <a href="https://www.linkedin.com/in/mateocohen/" target="_blank" rel="noopener noreferrer" className="text-2xl sm:text-3xl text-white font-semibold tracking-normal hover:text-gray-400 transition-colors duration-300 font-switzer" onClick={toggleMenu} data-id="element-106" data-mp="2jjpf5spcqm1g">
                  LINKEDIN
                </a>
              </li>
            </ul>
          </nav>
        </div>}
    </>;
}